import kvSyncSubscriber from '@/mqtt/kvSync'

const getAttributeChangesTopic = ({ presentationId }) => {
  return `presentation-${presentationId}-slide-attributes/#`
}
const slideAttributesAction = {
  subscribeAttributeChanges: async (
    { commit },
    { presentationId },
  ) => {
    if (!presentationId) return
    const callbackWrapper = (topic, message) => {
      // For reference: the topic is form in general-api
      // services-layer/slide-service
      const regex = /slide-(\d+)-(.+)$/
      const match = topic.match(regex)
      if (!match) return
      const [, slideId, attributeKey] = match
      const attributeValue = JSON.parse(message)
      const attributeUpdated = { [attributeKey]: attributeValue }
      commit('updateAttributes', { presentationId, slideId, attributes: attributeUpdated })
    }
    const key = getAttributeChangesTopic({ presentationId })
    kvSyncSubscriber.subscribeKey(key, callbackWrapper)
  },
  unsubscribeAttributeChanges: (_, { presentationId }) => {
    kvSyncSubscriber.unsubscribeKey(getAttributeChangesTopic({ presentationId }))
  },
}

export default slideAttributesAction
